<div class="flex flex-col gap-1.25">
  <!-- HEADER -->
  <div class="main flex items-center justify-between h-[4.5rem]">
    <!-- LEFT SELECTOR AND INPUT -->
    <div class="w-[45rem] bg-black-3 h-[2.5rem] rounded-[0.5rem]"></div>

    <!-- RIGHT BUTTONS -->
    <div class="flex flex-row gap-0.46875">
      <div class="w-[6rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[6rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[7rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[7rem] bg-black-1 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[8.55rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
    </div>
  </div>

  <!-- SETTINGS  -->
  <div class="w-[7rem] bg-black-5 h-[1.5rem] rounded-[0.5rem]"></div>

  <div class="grid grid-cards-container h-[11.125rem] gap-1.25">
    <div class="main flex flex-col left-container gap-[2rem]">
      <div class="flex gap-0.9375">
        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[12rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[5rem] h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[5rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10.5rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>
      </div>

      <div class="flex gap-0.9375">
        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[12rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[5rem] h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[5rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>

        <div class="flex flex-col gap-0.46875">
          <span class="w-[6rem] bg-black-2 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10.5rem] bg-black-3 h-[2rem] rounded-[0.5rem]"></span>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-3 right-container gap-1.25">
      @for (card of [].constructor(6); track $index) {
        <div class="main settings-card">
          <span class="w-[6rem] bg-black-2 h-[1rem] rounded-[0.5rem]"></span>
          <span class="w-[8rem] bg-black-2 h-[1.5rem] rounded-[0.5rem]"></span>
        </div>
      }
    </div>
  </div>

  <!-- PORTFOLIO  -->
  <div class="w-[7rem] bg-black-5 h-[1.5rem] rounded-[0.5rem]"></div>

  <div class="main table-fms">
    <table>
      <thead>
        <tr>
          <th class="fix-w-19p75"></th>
          <th class="fix-w-0p25 blank-space"></th>
          @for (i of [].constructor(9); track $index) {
            <th
              class="fix-w-5p5"
              [class.blank-space]="[3, 8].includes($index)">
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (i of [].constructor(5); track $index) {
          <tr
            class="animation-wrapper"
            app-table-empty-state
            [tdAmount]="10"
            [blankSpaceIndices]="[1, 5]">
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- ANALYTICS  -->
  <div class="w-[7rem] bg-black-5 h-[1.5rem] rounded-[0.5rem]"></div>

  <div class="main grid grid-cards-container gap-1.25">
    <div class="table-fms width-unset left-container">
      <table>
        <thead>
        <tr>
          <th colspan="6"></th>
        </tr>
        </thead>
        <tbody>
          @for (i of [].constructor(5); track $index) {
            <tr
              class="animation-wrapper"
              app-table-empty-state
              [tdAmount]="6">
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="grid grid-cols-3 right-container gap-0.625">
      @for (card of [].constructor(9); track $index) {
        <div class="card flex flex-col gap-0.3125">
          <span class="w-[6rem] bg-black-1 h-[0.7rem] rounded-[0.5rem]"></span>
          <span class="w-[10rem] bg-black-2 h-[1rem] rounded-[0.5rem]"></span>
        </div>
      }
    </div>
  </div>

  <!-- CHARTS  -->

  <div class="flex flex-col gap-1.25">
    <div class="flex gap-1.25">
      @for (chart of [
        { title: 'Total proceeds', subtitle: 'by group' },
        { title: 'Total proceeds', subtitle: 'by exit size' }
      ]; track $index) {
        <div class="main flex flex-col items-center w-full h-full">
          <div class="flex gap-0.15625">
            <span class="font-2 bold600">{{chart.title}}</span>
            <span class="font-2 bold600 main-8">{{chart.subtitle}}</span>
          </div>
          <div class="bg-black-3 w-full h-[28rem] rounded"></div>
        </div>
      }
    </div>

    @for (chart of ['Exit size & Holdings', 'Average Investment & Proceeds']; track $index) {
      <div class="main flex flex-col items-center gap-1.25">
        <span class="font-2 bold600">{{chart}}</span>
        <div class="bg-black-3 w-full h-[28rem] rounded"></div>
      </div>
    }
  </div>
</div>
